import React from 'react';
import { motion } from 'framer-motion';
import { FiCheck, FiMinus } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const strong = [
  'Intake, qualification, and FAQ resolution',
  'Structured call summaries and handoffs',
  'After-hours and overflow answering',
  'Department routing with caller context',
  'CRM, helpdesk, and Slack delivery',
];

const escalates = [
  'Legal, compliance, or regulatory questions',
  'Emotionally sensitive or safety-critical situations',
  'Issues requiring screen sharing or remote access',
  'Novel situations outside the configured workflow',
  'Decisions requiring human judgment or authority',
];

const HonestLimitations = () => (
  <section className="py-20 border-t" style={{ background: '#0a0a0a', borderColor: '#1a1a1a' }}>
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-12">
        <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{ color: '#4ade80' }}>Transparency</p>
        <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#f1f1f1' }}>
          Built for structured intake and routing —<br className="hidden md:block" /> not everything.
        </h2>
        <p className="text-base max-w-xl leading-relaxed" style={{ color: '#888' }}>
          We'd rather be honest about scope than oversell. This section is here to help you evaluate fit.
        </p>
      </motion.div>
      <div className="grid md:grid-cols-2 gap-8">
        <div className="p-8 rounded-2xl border" style={{ background: '#111', borderColor: '#1f1f1f' }}>
          <h3 className="text-base font-semibold mb-6" style={{ color: '#f1f1f1' }}>Strong at</h3>
          <div className="space-y-4">
            {strong.map((item, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: '#1a3a2a' }}>
                  <SafeIcon icon={FiCheck} className="w-3 h-3" style={{ color: '#4ade80' }} />
                </div>
                <span className="text-sm leading-relaxed" style={{ color: '#aaa' }}>{item}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="p-8 rounded-2xl border" style={{ background: '#111', borderColor: '#1f1f1f' }}>
          <h3 className="text-base font-semibold mb-6" style={{ color: '#f1f1f1' }}>Escalates to your team</h3>
          <div className="space-y-4">
            {escalates.map((item, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: '#1f1f1f' }}>
                  <SafeIcon icon={FiMinus} className="w-3 h-3" style={{ color: '#555' }} />
                </div>
                <span className="text-sm leading-relaxed" style={{ color: '#666' }}>{item}</span>
              </div>
            ))}
          </div>
          <div className="mt-6 pt-6 border-t" style={{ borderColor: '#1f1f1f' }}>
            <p className="text-sm leading-relaxed" style={{ color: '#666' }}>
              When escalation is triggered, the AI captures full context and routes the caller to your team — no dead end, no lost information.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HonestLimitations;